let mobileReg = new RegExp('^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\\d{8}$');

export default {
    /**
     * 验证手机号是否正确
     * @param {*} mobile 
     */
    isMobile(mobile) {
        return mobile && mobileReg.test(mobile);
    }
}